import type { EmailValue } from 'components/EmailTo'
import type { BaseFile } from 'config'

/** An internal user who can be @mentioned in a note. */
export type MentionUser = { name: string; email: string; accountType: string }

/** A department: one of the tenant's internal account types, with how many people it holds. */
export type MentionGroup = { key: string; title: string; count: number }

export interface INoteButton {
  label: string
  url: string
  type: 'button' | 'href'
}

export interface INote {
  id: number
  loanNumber: number
  noteBy: string
  content: string
  files: BaseFile[]
  links: INoteButton[]
  notifiers: EmailValue
  subject: string
  messageId: string | null
  history: string
  from: string
  to: string[]
  isRead: boolean
  readByReceiver: boolean
  isPinned: boolean
  pinnedAt: Date | null
  pinnedBy: string | null
  createdAt: Date
  updatedAt: Date
}

// Fired after a note is pinned/unpinned so the banner at the top of the loan refetches.
export const PINNED_NOTES_CHANGED_EVENT = 'loan-pinned-notes-changed'

export enum NotePageType {
  GLOBAL = 'global',
  SERVICING = 'servicing',
  REO = 'reo',
}

// Labels for the notes lists a template can be restricted to, used by the Admin template editors.
export const NotePageTypeOptions: Record<NotePageType, string> = {
  [NotePageType.GLOBAL]: 'Loan Notes',
  [NotePageType.SERVICING]: 'Servicing Notes',
  [NotePageType.REO]: 'REO Notes',
}
